/**
 * Individual - Interface for named individuals (owl:NamedIndividual).
 *
 * Extends Node with individual-specific properties. Both TBox individuals
 * (defined in ontologies for enumerations/hasValue) and ABox individuals
 * (user-created instances) implement this interface.
 *
 * This provides a unified type for handling individuals across the application,
 * enabling features like object property dropdowns to work with both types.
 */
/**
 * Type guard to check if a Node is an Individual.
 */
export function isIndividual(node) {
    return 'classUris' in node && 'isInstanceOf' in node;
}
